import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/components/_text.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem('text', styles);
var Text = function Text(_ref) {
  var Elem = _ref.Elem,
      extraClasses = _ref.extraClasses,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["Elem", "extraClasses", "children"]);

  return React.createElement(Elem, _extends({
    className: bem.b(false, extraClasses)
  }, rest), children);
};
Text.displayName = 'Text';
Text.defaultProps = {
  children: null,
  Elem: 'p',
  extraClasses: ''
};
Text.propTypes = {
  /** Custom HTML tag, if needed (default is p)  */
  Elem: PropTypes.string,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children are required */
  children: PropTypes.node
};
var Text$1 = Injecss(Text, styles);

export default Text$1;
export { Text };
